<template>
    <div>
        <Card :padding="0">
            <p slot="title" class="card-title">
                <Icon type="map"></Icon>
                各产品累计用户数每日趋势
            </p>
            <div style="height: 360px">
                <div style="width:100%;height:100%;" id="data_sourcetr" v-show="!isShow"></div>
                <div class="chart-error" v-show="isShow">
                    <div class="detail">
                        <span class="detail">暂无数据</span>
                    </div>
                </div>
            </div>
        </Card>
    </div>
</template>
<script>
    import {findLessPreDayUseNum} from "../../../service/api.js";

    export default {
        name: "pro-user-day-trend",
        data () {
            return {
                isShow: false, //是否显示缺醒图
                proList: [
                    //产品集合
                    {
                        type: 1,
                        name: "大屏",
                        dataList: [] //日期集合
                    },
                    {
                        type: 2,
                        name: "移动授课助手",
                        dataList: []
                    },
                    {
                        type: 3,
                        name: "备课助手",
                        dataList: []
                    },
                    {
                        type: 4,
                        name: "智能PC",
                        dataList: []
                    }
                ]
            };
        },
        methods: {
            /**
             * 获取各产品累计用户数每日趋势
             */
            async getLessPreDayUseNum () {
                let _this = this;
                await findLessPreDayUseNum()
                    .then(function (data) {
                        _this.proList = data;
                        _this.handleDate(_this.proList);
                        _this.initDataSource();
                        _this.isShow = _this.proList.length <= 0;
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 处理日期
             */
            handleDate (data) {
                let dateArr = [];
                let startDate="";
                let countArr=[];
                data.forEach((arr)=>{
                    countArr.push(arr.timeList.length);
                });
                let maxCount = countArr.sort((a,b)=>{return b-a})[0];
                for(let i=0;i<data.length;i++){
                    //获取需要展示的日期集合
                    if(data[i].timeList.length===maxCount){
                        dateArr = data[i].timeList
                    }
                    //筛选出不正常的日期集合
                    if(data[i].timeList.length!==dateArr.length) {
                        //获取不正常集合的开始日期
                        startDate = data[i].timeList[0].date;
                        for (let j = 0; j < dateArr.length; j++) {
                            let obj = {};
                            if (dateArr[j].date !== startDate) {
                                obj.date = dateArr[j].date;
                                obj.number = 0;
                            } else {
                                break;
                            }
                            data[i].timeList.push(obj);
                            data[i].timeList=this.dataRank(data[i].timeList);
                        }
                    }
                }
            },
            /**
             *对日期进行排序
             */
            dataRank(data){
                for(let i=0;i<data[i].date;i++){
                    data[i].date=this.dateToTime(data[i].date);
                }
                //按升序排序
                data.sort(function (a, b) {
                    return b.date < a.date ? 1 : -1;
                });
                return data;
            },
            /**
             * 将日期转换为时间戳
             */
            dateToTime (str) {
                return (new Date(str.replace(/-/g, '/'))).getTime(); //用/替换日期中的-是为了解决Safari的兼容
            },
            /**
             * 各产品累计用户数每日趋势数据获取
             */
            initDataSource () {
                let dataSource = this.$echarts.init(
                    document.getElementById("data_sourcetr")
                );
                let dateArr = [];
                let proNameArr = [];
                let dataList = [];
                for (let i = 0; i < this.proList.length; i++) {
                    proNameArr.push(this.proList[i].name);
                    let obj = {};
                    obj.name = this.proList[i].name;
                    obj.type = "line";
                    // obj.stack = "总量";
                    let data = [];
                    for (let j = 0; j < this.proList[i].timeList.length; j++) {
                        if (this.proList[i].type === 1) {
                            dateArr.push(this.proList[i].timeList[j].date);
                        }
                        data.push(this.proList[i].timeList[j].number);
                    }
                    obj.data = data;
                    dataList.push(obj);
                }
                const option = {
                    tooltip: {
                        trigger: "axis",
                        axisPointer: {
                            // 坐标轴指示器，坐标轴触发有效
                            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
                        },
                        //自定义内容
                        formatter: function (params, ticket, callback) {
                            var htmlStr = '';
                            for (var i = 0; i < params.length; i++) {
                                var param = params[i];
                                var xName = param.name;//x轴的名称
                                var seriesName = param.seriesName;//图例名称
                                var value = param.value;//y轴值
                                var color = param.color;//图例颜色

                                if (i === 0) {
                                    htmlStr += xName + '<br/>';//x轴的名称
                                }
                                htmlStr += '<div>';
                                //为了保证和原来的效果一样，这里自己实现了一个点的效果
                                htmlStr += '<span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:' + color + ';"></span>';

                                //圆点后面显示的文本
                                htmlStr += seriesName + '：' + value + '人使用';

                                htmlStr += '</div>';
                            }
                            return htmlStr;
                        }
                    },
                    legend: {
                        data: proNameArr
                    },
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "3%",
                        containLabel: true
                    },
                    xAxis: {
                        type: "category",
                        boundaryGap: false,
                        data: dateArr
                    },
                    yAxis: {
                        type: "value"
                    },
                    color: [
                        "#FACBC0",
                        "LightPink",
                        "Moccasin",
                        "LightBlue",
                        "#DDA0DD",
                        "#60c0dd"
                    ],
                    series: dataList
                };
                dataSource.setOption(option);

                window.addEventListener("resize", function () {
                    dataSource.resize();
                });
            }
        },
        mounted () {
            this.getLessPreDayUseNum();
        }
    };
</script>

<style lang="scss" scoped>
    @import "../../../style/common";
</style>
